import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { IConfigurationData, IConfigurationService } from '../../services/configuration/configuration-service.interface';
import { INOTIFICATIONS_SERVICE, NotificationsService } from '@platform500services/p500-ui-kit';

@Component({
  selector: 'gtd-auth-layout',
  templateUrl: './auth.layout.html',
  providers: [
    {
      provide: INOTIFICATIONS_SERVICE,
      useClass: NotificationsService,
    },
  ],
})
export class AuthLayoutComponent {
  public background: string;
  public textColor: string;
  public buttonsColor: string;
  public hideCopyright = false;
  public currentYear = new Date().getFullYear();
  constructor(
    @Inject('IConfigurationService') private configurationService: IConfigurationService,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {
    this.activatedRoute.data.subscribe((data: { configurationData: IConfigurationData }) => {
      this.configurationService.setData(data.configurationData);
      this.document.getElementById('app-favicon').setAttribute('href', data.configurationData ? data.configurationData.brand.icon : '');
    });
    const brand = this.configurationService.data().brand;
    try {
      const { affiliate_crm_login_background_image: backgroundImage, affiliate_crm_login_settings: loginSettings } = JSON.parse(
        brand.affiliate_crm_signin_signup_pages_settings
      );
      if (backgroundImage) {
        this.background = `url(${backgroundImage})`;
      }
      if (loginSettings) {
        const { buttonsColor, textColor } = loginSettings;
        this.buttonsColor = buttonsColor;
        this.textColor = textColor;
        this.hideCopyright = loginSettings.affiliate_crm_white_label;
      }
    } catch {}
  }
}
